
import { ConnectorConstant } from "./ConnectorConstant";

const ConnectorAction = {};

ConnectorAction.getConnectorData = (payload) => {
   
  const { filter, search_term ,page,limit,from_date,to_date} = payload ;
    return {
        type: ConnectorConstant.CONNECTOR_SAGA, 
        payload: {
          filter: filter,
          search_term: search_term,
          page:page,
          limit:limit,
          from_date:from_date,
          to_date:to_date
        },
    }
};

ConnectorAction.postConnectorData = (payload ) => {
    return {
      type: ConnectorConstant.ADD_CONNECTOR_SAGA,
      payload: payload,
    };
  };


  ConnectorAction.postBulkData = (payload) => {
    return {
      type: ConnectorConstant.POST_CONNECTOR_BULK_SAGA,
      payload: payload,
    };
  };
  ConnectorAction.deleteconnectors = (id) => {
    return {
      type: ConnectorConstant.DELETE_CONNECTOR_SAGA,
      payload: id,
    };
  };
export { ConnectorAction };